module.exports = __webpack_public_path__ + "static/media/filter_9_white_18dp.09ad83d7.svg";